import { render, staticRenderFns } from "./CollectionElementsAdd.vue?vue&type=template&id=81f5e16c&scoped=true&"
import script from "./CollectionElementsAdd.vue?vue&type=script&lang=js&"
export * from "./CollectionElementsAdd.vue?vue&type=script&lang=js&"
import style0 from "./CollectionElementsAdd.vue?vue&type=style&index=0&id=81f5e16c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f5e16c",
  null
  
)

export default component.exports